import React, { useMemo } from 'react';

interface CardProps {
  children: React.ReactNode;
  onClick: () => void;
  size: Size;
  selected?: boolean;
}

const sizes = {
  sm: 'h-28 w-28',
  md: 'h-40 w-40',
  lg: 'h-60 w-60',
  xl: 'h-80 w-80',
} as const;

type Size = keyof typeof sizes;

export default function Card({ children, onClick, size, selected = false }: CardProps) {
  const style = useMemo(() => {
    if (selected) return 'border-blue-500 border';
    return '';
  }, [selected]);

  return (
    <button
      onClick={onClick}
      className={`relative flex ${sizes[size]} ${style} items-center justify-center rounded-2 bg-white p-4 shadow-default hover:shadow-hover`}
    >
      {children}
    </button>
  );
}
